import { Paginacao } from '@app/models/util/paginacao';
export class ReceberAtrasadosRelatorios {

  Id: number;
  Processo: string;
  Numero: string;
  Valor: number;
  ValorRecebido: number;
  Emissao: Date;
  Vencimento: Date;
  Participante: string;
  Historico: string;
  TipoDR: string;
  Unidade: string;


  constructor() { }
}

export class FiltrosReceberAtrasadosRelatorios {

  UnidadeId: number;
  ParticipanteId: number;
  TipoData: 'Vencimento' | 'Emissao';
  DataInicial: string;
  DataFinal: string;
  ProcessoId: number;

  constructor() {
    const hoje = new Date();
    const mesAnterior = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 30);
    this.DataInicial = mesAnterior.toISOString().split('T')[0];
    this.DataFinal = hoje.toISOString().split('T')[0];
  }

}
